import RegisterPasien from "../../components/RegisterPasien/HomePagePasienOnline";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
